<template>
  <base-section
    id="program-calendar-premium-section"
  >
    <base-section-heading
      title="Program"
    >
    <v-container>
    Below you can download the Program of ETS23 in PDF format. <br><br>
      <v-btn
        href="ETS23_final_program.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 15px"
      >
        <v-icon
          left
          dark
        >
          mdi-cloud-download
        </v-icon>
        Program in PDF
      </v-btn>
    </v-container>
    </base-section-heading>
    <base-section-heading
      title="Premium Program"
    >
    <div v-if="!logged">
    If you want to access the full program in digital version please insert below the password you were provided with after your registration to the conference.
    </div>
    </base-section-heading>
    <v-container>
      <div
        v-if="!logged"
      >
      <v-row align="center">
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
      >
      <v-text-field
          id="pass-premium"
          ref="passpremium"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          v-model="pass"
          lazy-validation
          label="Insert the password to access"
          filled
          rounded
      />
      </v-col>
      <v-col
        v-if="errsub"
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
      >
        <v-alert
          outlined
          type="error"
          text
        >
          <v-row align="center">
            <v-col class="grow">
              The password inserted is not correct
            </v-col>
            <v-col class="shrink">
              <v-btn
                color="error"
                @click="errsub = !errsub"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
        style="text-align: center !important; padding: 0px !important"
      >
      <v-btn
        class="font-weight-bold"
        color="white"
        width="60%"
        style="text-align: center !important"
        light
        x-large
        target="_blank"
        @click="login()"
      >
        Log in
      </v-btn>
      </v-col>
      </v-row>
      </div>
    <div
      v-if="logged"
    >
    <base-section-heading
      divider="null"
    >
      Below you can download the zip file with all the proceedings of the conference. <br><br>
      <v-btn
        href="ETS23_proceedings.zip"
        rounded
        color="success"
        dark
        download
        style="padding: 15px"
      >
        <v-icon
          left
          dark
        >
          mdi-folder-zip
        </v-icon>
        Proceedings in zip archive
      </v-btn>
      <br>
      <br>
        <a
        href="https://cas.polito.it/ETS23_proceedings/"
        target="_blank"
        >
        Here</a>
        you can find the proceedings of the conference. Please leave the username blank and use the same password you used to access the premium program.
        <br>
          To access the conference in virtual mode, please use this zoom link:
          <a
          href="https://ec-lyon-fr.zoom.us/j/94288225176?pwd=Z3NGUHdjRkdRcDNzZ3c4dFJQVTZGUT09"
          target="_blank"
          >
          Zoom Meeting for ETS'23
          </a><br><strong>Meeting ID: 942 8822 5176 Passcode: 021634</strong>, if required.
    </base-section-heading>

      <v-sheet
      v-if="!isMobileDevice()"
      >
    <v-calendar
        :start="minDate"
        :end="maxDate"
        type="week"
        ref="calendarPremium"
        :weekdays="days"
        event-overlap-mode="column"
        interval-count="12"
        first-interval="08:30"
        :events="events"
        interval-height="80"
        interval-minutes="60"
        :weekday-format="formatMonth"
        :day-format="formatDay"
        @click:event="handleEventClick"
    ></v-calendar>
    <v-dialog
        v-model="selectedOpen"
        :activator="selectedElement"
        width="60%"
      >
        <v-card>
          <div
          style="background-color: #FFFFFF; position:sticky; top:0; z-index: 999;"
          >
            <v-card-title>{{ selectedEvent.name }}</v-card-title>
            <v-card-subtitle
              v-if="!(['P1', 'P2', 'P3', 'P4', 'SENT', 'Lch', 'Lon', 'Lee', 'L23'].includes(selectedEvent.id))"
            >
              <i>
              Room: <strong>{{ selectedEvent.room }}</strong> <br>
              <!---Moderators: <strong>{{ selectedEvent.moderators}}</strong><br>--->
              {{ selectedEvent.moderators }}<br>
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
            <v-card-subtitle
              v-else-if="!(['SENT'].includes(selectedEvent.id))"
            >
              <i>
              Room: <strong>{{ selectedEvent.room }}</strong> <br>
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
            <v-card-subtitle
            v-else
            >
              <i>
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
          </div>
          <v-card-text>
              <div
                v-if="(selectedEvent.name.includes(['Break']) && (['P1', 'P2', 'P3', 'P4']).includes(selectedEvent.id))"
              >
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Coffee Break Menu
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-html="selectedEvent.menu">
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <br><br>
              </div>
              <div
                v-for="(paper, i) in selectedEvent.papers"
                :key="i"
              >
              <v-divider />
              <br>
              <v-btn
                  v-if="(['K1', 'K2'].includes(selectedEvent.id))"
                  color="primary"
                  style="text-transform: capitalize"
                  type="text"
                  elevation="3"
                  :to="selectedEvent.id"
                >
                <v-icon left>
                  mdi-open-in-new
                </v-icon>
                <strong>Title: {{ paper.title }} </strong>
              </v-btn>
              <v-btn
                v-else-if="!(['H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON', 'T1', 'T2', 'S2C', 'SENT', 'Lch', 'Lon', 'Lee', 'L23'].includes(selectedEvent.id)) && !(['McCluskey 2'].includes(paper.id))"
                elevation="3"
                color="primary"
                type="text"
                retain-focus-on-click
                style="text-transform: capitalize"
                @click.capture="handleEventClickPaper($event, paper)"
              >
              <strong>Title: {{ paper.title }} </strong>  <div v-if="(['62', '118', '117', '75', '84', '124'].includes(paper.id))"><span style="color:red; font-size:23pt">*</span></div>
              </v-btn>
              <div
                v-if="(paper.type == 'virtual')"
              >
              <br>
                <span style="color: #204165;"><strong><v-icon left color="#204165">mdi-monitor-account</v-icon>VIRTUAL</strong></span>
              </div>
              <div
              v-if="(['McCluskey 2'].includes(paper.id))"
              >
              <s><strong>Title: {{ paper.title }} </strong></s> <br>
              <s><strong>{{ paper.authors }}</strong></s>
              <span style="color: red;"><strong> (withdrawn) </strong></span>
              </div>
              <div
                v-else-if="(['T1', 'T2'].includes(selectedEvent.id))"
              >
                <strong>Title: {{ paper.title }}</strong>
              </div>
              <br>
              <div
                v-if="(paper.id.includes('PhD Forum'))"
              >
              <br>
                <span style="color: #F57E71;"><strong>PhD Forum</strong></span>
              </div>
              <div
                v-else-if="(paper.id.includes('McCluskey'))"
              >
              <br>
                <span style="color: #F57E71;"><strong>McCluskey Award</strong></span>
              </div>
              <div
                v-else-if="(paper.id.includes('Ind'))"
              >
              <br>
                <span style="color: #7D8D8F;"><strong>Industrial Poster</strong></span>
              </div>
              <v-btn
                v-if="selectedEvent.ics != 'NA'"
                color="success"
                small
                style="text-transform: unset !important;"
                :href="selectedEvent.ics"
                download
              >
                <v-icon
                left
                >mdi-cloud-download</v-icon>
                Download .ics file
              </v-btn> <br>
              <div v-if="!(['McCluskey 2'].includes(paper.id))">
              <div v-if="!(['T1', 'T2', 'H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON', 'S2C', 'SENT', 'Lon', 'Lee', 'Lch', 'L23'].includes(selectedEvent.id))">
              <i> {{ paper.authors }} </i>
              </div>
              <div
              v-else
              v-html="paper.authors"
              >
              </div>
              </div>
              <br>
              <v-row
                v-if="(['SENT'].includes(selectedEvent.id))"
                align="center"
                justify="space-around"
              >
              <v-btn
                v-if="(['SENT'].includes(selectedEvent.id))"
                href="ETS23_gala_dinner_menu.pdf"
                style="text-transform: capitalize"
                download
              >
                <v-icon
                left
                >
                  fas fa-file-pdf
                </v-icon>
                Download the Gala Dinner Menu
              </v-btn>
              <v-btn
                color="primary"
                style="text-transform: capitalize"
                type="text"
                elevation="3"
                v-if="(['SENT'].includes(selectedEvent.id))"
                retain-focus-on-click
                to="social-event"
              >
                <v-icon left>
                    mdi-open-in-new
                </v-icon>
              <strong>Learn More </strong>
              </v-btn>
              </v-row>
              <div v-if="(['T1', 'T2','H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON'].includes(selectedEvent.id))">
                <div v-if="paper.abstract != 'TBA'">
                <strong>Abstract</strong>: {{ paper.abstract }}
                </div>
              </div>
              <div v-if="(['62', '118', '117', '75', '84', '124'].includes(paper.id))">
                <br>
                <span style="color: red"><strong><i>*Best Paper Candidate</i></strong></span><br><br>
              </div>
              <div v-else>
                <br>
              </div>
              </div>
            </v-card-text>
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="selectedOpen = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
              <v-dialog
                width="60%"
                v-model="dialog"
                no-click-animation
                hide-overlay
                :activator="selectedElementPaper"
                @click:outside="closeVideo(selectedPaper)"
              >
              <v-card>
                <div
                style="background-color: #FFFFFF; position:sticky; top:0; z-index: 999;"
                >
                  <v-card-title>
                    <v-btn
                      icon
                      color="primary"
                      @click="closeVideo(selectedPaper)"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    {{ selectedPaper.title }}</v-card-title>
                  <v-card-subtitle
                    v-if="!(['P1', 'P2', 'P3', 'P4', 'T1', 'T2'].includes(selectedEvent.id))"
                  >
                    <i>
                    Room: <strong>{{ selectedEvent.room }}</strong> <br>
                    <!---Moderators: <strong>{{ selectedEvent.moderators}}</strong><br>--->
                    <span v-html="selectedPaper.speakers" /> <br>
                    <strong><span style="color: #42A5F6">{{ selectedPaper.interval }}</span></strong>
                    </i>
                  </v-card-subtitle>
                  <v-card-subtitle
                    v-else
                  >
                    <i>
                    Room: <strong>{{ selectedEvent.room }}</strong> <br>
                    <span v-html="selectedPaper.speakers" /> <br>
                    <strong><span style="color: #42A5F6">{{ selectedPaper.interval }}</span></strong>
                    </i>
                  </v-card-subtitle>
                </div>
                <v-card-text>
                  <!---
                  <v-btn
                    color="success"
                    small
                    style="text-transform: unset !important;"
                    href="https://calendar.google.com/calendar/event?action=TEMPLATE&amp;tmeid=NmIxZGM0czVyMGxxbHNtdXRraDJtbXN1bm0gNDcyMjZkMTcwZGVhYmE5YTNlNTkzZWI3YTc4NzYxZjAzMTFmNDM5NGZiYzY0ZmZiZTdlNTQ4MGU0YWVlYWZmMkBn&amp;tmsrc=47226d170deaba9a3e593eb7a78761f0311f4394fbc64ffbe7e5480e4aeeaff2%40group.calendar.google.com"
                  >
                    <v-icon
                    left
                    >mdi-plus</v-icon>
                    Add to Google calendar
                  </v-btn> <br><br>
                  --->
                  <div
                    v-if="(selectedPaper.type == 'virtual')"
                  >
                  <br>
                    <span style="color: #204165;"><strong><v-icon left color="#204165">mdi-monitor-account</v-icon>VIRTUAL</strong></span>
                  </div>
                  <br>
                  <v-btn
                    v-if="selectedPaper.ics != 'NA'"
                    color="success"
                    small
                    style="text-transform: unset !important;"
                    :href="selectedPaper.ics"
                    download
                  >
                    <v-icon
                    left
                    >mdi-cloud-download</v-icon>
                    Download .ics file
                  </v-btn> <br><br>
                  <v-btn
                    v-if="selectedPaper.pdf != 'NA'"
                    color="red"
                    icon
                    :ripple="false"
                    :href="'https://cas.polito.it/ETS23/proceedings/' + selectedPaper.pdf"
                    target="_blank"
                    download
                  >
                    <v-icon
                    left
                    >fas fa-file-pdf</v-icon>
                  </v-btn> <br><br>
                  <div
                    v-if="selectedPaper.bio != 'NA'"
                  >
                  <br>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Speaker Bio
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        {{ selectedPaper.bio }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <br><br>
                  </div>
                  <div v-if="selectedPaper.abstract != 'TBA'">
                  <strong>Abstract</strong>: {{ selectedPaper.abstract }}
                  </div>
                  <br>
                  <div
                    v-if="selectedPaper.pitch != 'NA'"
                  >
                  <strong>Pitch video:</strong> <br>
                  <iframe
                  :id="selectedPaper.title"
                  :src="selectedPaper.pitch"
                  style="padding: 0; margin: 0; border:0"
                  allowfullscreen
                  >
                  </iframe>
                  </div>
                  <br>
                  <div
                    v-if="selectedPaper.video != 'NA'"
                  >
                  <strong>Full presentation video:</strong> <br>
                  <iframe
                  :id="selectedPaper.title"
                  :src="selectedPaper.video"
                  style="padding: 0; margin: 0; border:0"
                  allowfullscreen
                  >
                  </iframe>
                  </div>
                </v-card-text>
                <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeVideo(selectedPaper)"
                >
                  Close
                </v-btn>
              </v-card-actions>
              </v-card>
              </v-dialog>
        </v-card>
      </v-dialog>
      </v-sheet>
    <div
    v-else
    >
      <v-toolbar
      flat
      >
          <v-btn
            v-if="vertical"
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="vertical"
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
           <v-toolbar-title>
            Day {{ countDate+1 }}
          </v-toolbar-title>
      </v-toolbar>
      <v-sheet
      height="700"
      >
      <v-calendar
        ref="calendarPremium"
        :type="typeView"
        :start="minDate"
        :end="maxDate"
        :events="events"
        v-model="focus"
        :weekdays="days"
        event-overlap-mode="column"
        @click:event="handleEventClick"
        interval-count="12"
        interval-height="80"
        interval-minutes="60"
        first-time="08:00"
        :weekday-format="formatMonth"
        :day-format="formatDay"
        v-touch="{
          left: () => next(),
          right: () => prev(),
        }"
      >
      </v-calendar>
      <v-dialog
        v-model="selectedOpen"
        :activator="selectedElement"
      >
        <v-card>
          <div
          style="background-color: #FFFFFF; position:sticky; top:0; z-index:999;"
          >
            <v-card-title>{{ selectedEvent.name }}</v-card-title>
            <v-card-subtitle
              v-if="!(['P1', 'P2', 'P3', 'P4', 'T1', 'T2', 'SENT', 'Lch', 'Lon', 'Lee', 'L23'].includes(selectedEvent.id))"
            >
              <i>
              Room: <strong>{{ selectedEvent.room }}</strong> <br>
              <!---Moderators: <strong>{{ selectedEvent.moderators}}</strong><br>--->
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
            <v-card-subtitle
              v-else-if="!(['SENT'].includes(selectedEvent.id))"
            >
              <i>
              Room: <strong>{{ selectedEvent.room }}</strong> <br>
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
            <v-card-subtitle
            v-else
            >
              <i>
              <strong><span style="color: #42A5F6">{{ selectedEvent.interval }}</span></strong>
              </i>
            </v-card-subtitle>
          </div>
            <v-card-text>
              <v-dialog
                v-model="dialog"
                no-click-animation
                :activator="selectedElementPaper"
                @click:outside="closeVideo(selectedPaper)"
              >
              <v-card>
                <div
                style="background-color: #FFFFFF; position:sticky; top:0; z-index: 999;"
                >
                  <v-card-title>
                    <v-btn
                      icon
                      color="primary"
                      @click="closeVideo(selectedPaper)"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    {{ selectedPaper.title }}</v-card-title>
                  <v-card-subtitle
                    v-if="!(['P1', 'P2', 'P3', 'P4', 'T1', 'T2'].includes(selectedEvent.id))"
                  >
                    <i>
                    Room: <strong>{{ selectedEvent.room }}</strong> <br>
                    <!---Moderators: <strong>{{ selectedEvent.moderators}}</strong><br>--->
                    <span v-html="selectedPaper.speakers" /> <br>
                    <strong><span style="color: #42A5F6">{{ selectedPaper.interval }}</span></strong>
                    </i>
                  </v-card-subtitle>
                  <v-card-subtitle
                    v-else
                  >
                    <i>
                    Room: <strong>{{ selectedEvent.room }}</strong> <br>
                    <span v-html="selectedPaper.speakers" /> <br>
                    <strong><span style="color: #42A5F6">{{ selectedPaper.interval }}</span></strong>
                    </i>
                  </v-card-subtitle>
                </div>
                <v-card-text>
                  <!---
                  <v-btn
                    color="success"
                    small
                    style="text-transform: unset !important;"
                    href="https://calendar.google.com/calendar/event?action=TEMPLATE&amp;tmeid=NmIxZGM0czVyMGxxbHNtdXRraDJtbXN1bm0gNDcyMjZkMTcwZGVhYmE5YTNlNTkzZWI3YTc4NzYxZjAzMTFmNDM5NGZiYzY0ZmZiZTdlNTQ4MGU0YWVlYWZmMkBn&amp;tmsrc=47226d170deaba9a3e593eb7a78761f0311f4394fbc64ffbe7e5480e4aeeaff2%40group.calendar.google.com"
                  >
                    <v-icon
                    left
                    >mdi-plus</v-icon>
                    Add to Google calendar
                  </v-btn> <br><br>
                  --->
                  <div
                    v-if="(selectedPaper.type == 'virtual')"
                  >
                  <br>
                    <span style="color: #204165;"><strong><v-icon left color="#204165">mdi-monitor-account</v-icon>VIRTUAL</strong></span>
                  </div>
                  <br>
                  <v-btn
                    v-if="selectedPaper.ics != 'NA'"
                    color="success"
                    small
                    style="text-transform: unset !important;"
                    :href="selectedPaper.ics"
                    download
                  >
                    <v-icon
                    left
                    >mdi-cloud-download</v-icon>
                    Download .ics file
                  </v-btn> <br><br>
                  <v-btn
                    v-if="selectedPaper.pdf != 'NA'"
                    color="red"
                    icon
                    :ripple="false"
                    :href="'https://cas.polito.it/ETS23/proceedings/' + selectedPaper.pdf"
                    download
                    target="_blank"
                  >
                    <v-icon
                    left
                    >fas fa-file-pdf</v-icon>
                  </v-btn> <br><br>
                  <div
                    v-if="selectedPaper.bio != 'NA'"
                  >
                  <br>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Speaker Bio
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        {{ selectedPaper.bio }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <br><br>
                  </div>
                  <div v-if="selectedPaper.abstract != 'TBA'">
                  <strong>Abstract</strong>: {{ selectedPaper.abstract }}
                  </div>
                  <br>
                  <div
                    v-if="selectedPaper.pitch != 'NA'"
                  >
                  <strong>Pitch video:</strong> <br>
                  <iframe
                  :id="selectedPaper.title"
                  :src="selectedPaper.pitch"
                  style="padding: 0; margin: 0; border:0"
                  allowfullscreen
                  >
                  </iframe>
                  </div>
                  <br>
                  <div
                    v-if="selectedPaper.video != 'NA'"
                  >
                  <strong>Full presentation video:</strong> <br>
                  <iframe
                  :id="selectedPaper.title"
                  :src="selectedPaper.video"
                  style="padding: 0; margin: 0; border:0"
                  allowfullscreen
                  >
                  </iframe>
                  </div>
                </v-card-text>
                <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeVideo(selectedPaper)"
                >
                  Close
                </v-btn>
              </v-card-actions>
              </v-card>
              </v-dialog>
              <div
                v-if="(selectedEvent.name.includes(['Break']) && (['P1', 'P2', 'P3', 'P4']).includes(selectedEvent.id))"
              >
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Coffee Break Menu
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-html="selectedEvent.menu">
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <br><br>
              </div>
              <div v-if="!(['P1', 'P2', 'P3', 'P4', 'SENT', 'Lch', 'Lon', 'Lee', 'L23'].includes(selectedEvent.id))">
              <!---Moderators: <strong>{{ selectedEvent.moderators}}</strong><br><br>--->
              {{ selectedEvent.moderators }}<br><br>
              </div>
              <div
                v-for="(paper, i) in selectedEvent.papers"
                :key="i"
              >
              <v-divider />
              <br>
              <v-btn
                v-if="(['K1', 'K2'].includes(selectedEvent.id))"
                color="primary"
                style="text-transform: capitalize"
                type="text"
                elevation="3"
                :to="selectedEvent.id"
              >
                <v-icon left>
                  mdi-open-in-new
                </v-icon>
              <strong>Title: {{ paper.title }} </strong>
              </v-btn>
              <v-btn
                v-else-if="!(['H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON', 'T1', 'T2', 'S2C', 'SENT', 'Lch', 'Lon', 'Lee', 'L23'].includes(selectedEvent.id)) && !(['McCluskey 2'].includes(paper.id))"
                elevation="3"
                color="primary"
                type="text"
                retain-focus-on-click
                style="text-transform: capitalize"
                @click.capture="handleEventClickPaper($event, paper)"
              >
              <strong>Title: {{ paper.title }} </strong>  <div v-if="(['62', '118', '117', '75', '84', '124'].includes(paper.id))"><span style="color:red; font-size:23pt">*</span></div>
              </v-btn>
              <br>
              <div
                v-if="(paper.type == 'virtual')"
              >
              <br>
                <span style="color: #204165;"><strong><v-icon left color="#204165">mdi-monitor-account</v-icon>VIRTUAL</strong></span>
              </div>
              <div
              v-if="(['McCluskey 2'].includes(paper.id))"
              >
              <s><strong>Title: {{ paper.title }} </strong></s> <br>
              <s><strong>{{ paper.authors }}</strong></s>
              <span style="color: red;"><strong> (withdrawn) </strong></span>
              </div>
              <div
                v-else-if="(['T1', 'T2'].includes(selectedEvent.id))"
              >
                <strong>Title: {{ paper.title }}</strong>
              </div>
              <br>
              <div
                v-if="(paper.id.includes('PhD Forum'))"
              >
              <br>
                <span style="color: #F57E71;"><strong>PhD Forum</strong></span>
              </div>
              <div
                v-else-if="(paper.id.includes('McCluskey'))"
              >
              <br>
                <span style="color: #F57E71;"><strong>McCluskey Award</strong></span>
              </div>
              <div
                v-else-if="(paper.id.includes('Ind'))"
              >
              <br>
                <span style="color: #7D8D8F;"><strong>Industrial Poster</strong></span>
              </div>
              <v-btn
                v-if="selectedEvent.ics != 'NA'"
                color="success"
                small
                style="text-transform: unset !important;"
                :href="selectedEvent.ics"
                download
              >
                <v-icon
                left
                >mdi-cloud-download</v-icon>
                Download .ics file
              </v-btn> <br>
              <div v-if="!(['McCluskey 2'].includes(paper.id))">
              <div v-if="!(['T1', 'T2', 'H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON', 'S2C', 'SENT', 'Lon', 'Lee', 'Lch', 'L23'].includes(selectedEvent.id))">
              <i> {{ paper.authors }} </i>
              </div>
              <div
              v-else
              v-html="paper.authors"
              >
              </div>
              </div>
              <br>
              <v-row
                v-if="(['SENT'].includes(selectedEvent.id))"
                align="center"
                justify="space-around"
              >
              <v-btn
                v-if="(['SENT'].includes(selectedEvent.id))"
                href="ETS23_gala_dinner_menu.pdf"
                style="text-transform: capitalize"
                download
              >
                <v-icon
                left
                >
                  fas fa-file-pdf
                </v-icon>
                Download the Gala Dinner Menu
              </v-btn>
              <v-btn
                color="primary"
                style="text-transform: capitalize"
                type="text"
                elevation="3"
                v-if="(['SENT'].includes(selectedEvent.id))"
                retain-focus-on-click
                to="social-event"
              >
                <v-icon left>
                    mdi-open-in-new
                </v-icon>
              <strong>Learn More </strong>
              </v-btn>
              </v-row>
              <div v-if="(['T1', 'T2','H1B', 'H5B', 'H8B', 'Hon', 'SEL', 'SON'].includes(selectedEvent.id))">
                <div v-if="paper.abstract != 'TBA'">
                <strong>Abstract</strong>: {{ paper.abstract }}
                </div>
              </div>
              <div v-if="(['62', '118', '117', '75', '84', '124'].includes(paper.id))">
                <br>
                <span style="color: red"><strong><i>*Best Paper Candidate</i></strong></span><br><br>
              </div>
              <div v-else>
                <br>
              </div>
              </div>
            </v-card-text>
              <v-card-actions>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="selectedOpen = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
        </v-card>
      </v-dialog>
      </v-sheet>
    </div>
    </div>
    </v-container>
  </base-section>
</template>
<script>
  import json from '@/../data/program.json'
  import DataService from '../../services/DataService'
  var md5 = require("blueimp-md5")

  export default {
    name: 'ProgramCalendarPremium',

    data: () => ({
      focus: '',
      countDate: 4,
      show1: false,
      pass: '',
      errsub: false,
      on: false,
      dialog: null,
      logged: false,
      attrs: null,
      isMobile: false,
      vertical: true,
      overDatePrev: false,
      overDateNext: false,
      selectedEvent: {
        name: '',
        start: '',
        end: '',
        id: '',
        ics: '',
      },
      selectedElement: null,
      selectedElementPaper: null,
      selectedPaper: {
        title: '',
        id: '',
        abstract: '',
        pitch: '',
        ics: '',
        type: '',
        video: '',
        pdf: '',
      },
      selectedOpen: false,
      typeView: 'day',
      days: [1, 2, 3, 4, 5],
      minDate: '2023-05-26',
      maxDate: '2023-05-26',
      events: json,
    }),
    mounted () {
      window.addEventListener('orientationchange', this.handleOrientationChange);
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      if (this.isMobile) {
        this.typeView = 'day'
        document.getElementById("program-calendar-premium-section").style = 'padding-bottom: 10px !important; margin-bottom: -160px !important;'
      }
      this.handleOrientationChange()
    },
    methods: {
      formatMonth(props) {
        // return new Date(props.date.replace(/-/g, '\/')).toLocaleDateString('en-US', {weekday: 'narrow'});
        return null
      },
      formatDay(props) {
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
        // const s = 'May ' + props.date.split('-')[2]
        // console.log(props)
        const s = days[props.weekday - 1] + ', ' + props.date.split('-')[2] + '/' + props.date.split('-')[1]
        return s
      },
      prev () {
        if (this.countDate > 0 && !this.overDatePrev && this.vertical) {
          this.$refs.calendarPremium.prev()
          this.countDate--
          if (this.countDate < 4) {
            this.overDateNext = false
          }
          if (this.countDate === 0) {
            this.overDatePrev = true
          }
        }
      },
      next () {
        if (this.countDate < 4 && !this.overDateNext && this.vertical) {
          this.$refs.calendarPremium.next()
          this.countDate++
          if (this.countDate > 0) {
            this.overDatePrev = false
          }
          if (this.countDate === 4) {
            this.overDateNext = true
          }
        }
      },
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      handleOrientationChange() {
        if (window.orientation === 90 || window.orientation === -90) {
          // The screen is flipped horizontally (landscape mode)
          // Do something here, e.g. switch to day view in v-calendar
          this.typeView = 'week'
          this.vertical = false
          document.getElementById('home-app-bar').style.display = 'none'
          document.getElementsByClassName('v-main')[0].style.padding = '0px'
        } else {
          // The screen is in portrait mode
          // Do something here, e.g. switch to week view in v-calendar
          this.typeView = 'day'
          this.vertical = true
          document.getElementById('home-app-bar').style.display = 'block'
          document.getElementsByClassName('v-main')[0].style.padding = '160px 0px'
        }
      },
      handleEventClick({ nativeEvent, event }) {
        if (event.papers.length > 0) {
          const open = () => {
            this.selectedEvent = event
            this.selectedElement = nativeEvent.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            //  this.selectedOpen = true
          }

          if (this.selectedOpen) {
            this.selectedOpen = false
            requestAnimationFrame(() => requestAnimationFrame(() => open()))
          } else {
            open()
          }

          nativeEvent.stopPropagation()
        }
      },
      handleEventClickPaper(event, paper) {
        const openP = () => {
          this.selectedPaper = paper
          this.selectedElementPaper = event.target
          //  requestAnimationFrame(() => requestAnimationFrame(() => this.dialog = true))
          this.dialog = true
        }
        if (this.dialog) {
          this.dialog = false
          //  requestAnimationFrame(() => requestAnimationFrame(() => openP()))
        } else {
          openP()
        }
        event.stopImmediatePropagation()
        event.stopPropagation()
      },
      closeVideo(paper) {
        if (document.getElementById(paper.title) != null) {
          var src = document.getElementById(paper.title).getAttribute('src')
          // console.log(document.getElementById(paper.title).getAttribute('src'))
          document.getElementById(paper.title).setAttribute('src', src)
        }
        this.dialog = false
      },
      login () {
        this.loading = true
        document.getElementById("pass-premium").setAttribute('disabled', '')
        var data = {
          ps: md5(this.pass),
        }
        DataService.log(data).then((response) => {
          document.getElementById("pass-premium").removeAttribute('disabled')
          this.$refs.passpremium.reset()
          if (response.status === 500) {
            this.errsub = true
          } else {
            this.errsub = false
            this.logged = true
          }
        }).catch((e) => {
          this.errsub = true
          document.getElementById("pass-premium").removeAttribute('disabled')
        })
      },
    },
  }
</script>
<style>
.v-btn {
  height: auto !important;
  padding: 10px 10px !important;
}
.v-calendar .v-event-timed {
  white-space: unset !important;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 80% !important;
}
.v-card {
  display: flex !important;
  flex-direction: column;
  max-height: 80% !important;
}
.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
.v-calendar .v-event-timed-container {
  position: unset !important;
}
.v-card__subtitle, .v-card__text {
  letter-spacing: 0.04rem !important;
}

.v-card__title {
  word-break: unset !important;
  letter-spacing: 0.05rem !important;
}
/*
#program-calendar-section {
  padding-bottom: 10px !important;
  margin-bottom: -160px !important;
}
*/
.v-btn__content {
  width: 100%;
  white-space: break-spaces;
}
</style>